<ng-container [formGroup]="component.form">
    <ng-content></ng-content>
</ng-container>